import { createNativeRequest, platform } from '@mx/core';
import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import { IPostBatchPresignedUploadUrlReq, IPostBatchPresignedUploadUrlResp } from '../types/upload';

// 上传图片
export const postBatchPresignedUploadUrl = async (
  data: IPostBatchPresignedUploadUrlReq,
  config?: AxiosRequestConfig
): Promise<IPostBatchPresignedUploadUrlResp> => {
  const url = '/weaver/api/v1/npc_editor/batch_presigned_upload_url';

  if (platform.isNativePlatform) {
    return createNativeRequest<IPostBatchPresignedUploadUrlResp>({
      method: 'POST',
      url,
      data,
    });
  }

  return await request.post(url, data, config);
};
